import { gql } from "lib/apolloClient";

export const aiTutorFragment = {
  aiConversationForFlaggedMessages: gql`
    fragment aiConversationForFlaggedMessagesItem on AiConversation {
      id
      entitySubType
      messages(filters: { isFlagged: true }) {
        totalCount
        edges {
          node {
            id
            authorType
            content
            metadata
            attachments {
              id
              name
              type
              mimeType
              url
              thumbUrl
              signedUrl
              title
              metadata
              streamUrl
              parentType
              createdBy {
                id
                type
              }
            }
          }
        }
      }
    }
  `,
};
